// @flow
import React, { Component } from 'react';
import Banner from 'app/common/react/ui/Banner';
import CuratorModal from 'app/common/react/components/HomefeedCurator/CuratorModal';
import i18n from 'app/common/lib/i18n';
import { Box } from 'gestalt';
import { track } from 'app/common/lib/react/analytics';

type Props = {
  experienceId: number,
  handleComplete: Function,
  handleDismiss: Function,
};

type State = {
  isCuratorModalOpen: boolean,
  isNagShown: boolean,
};

export default class CuratorUpsellHero extends Component<Props, State> {
  state = {
    isCuratorModalOpen: false,
    isNagShown: true,
  };

  handleCompleteExperience = () => {
    this.setState({ isNagShown: false, isCuratorModalOpen: true });
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.HOMEFEED_CURATOR_UPSELL,
      element: PCONST.thrift.ElementType.HOMEFEED_CURATOR_ENTRY_BUTTON,
    });
  };

  handleDismissExperience = () => {
    const { handleDismiss } = this.props;

    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.HOMEFEED_CURATOR_UPSELL,
      element: PCONST.thrift.ElementType.HOMEFEED_CURATOR_DISMISS_BUTTON,
    });
    handleDismiss();
  };

  handleHideCuratorModal = () => {
    this.setState({ isCuratorModalOpen: false });
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.HOMEFEED_CURATOR,
      element: PCONST.thrift.ElementType.HOMEFEED_CURATOR_DISMISS_BUTTON,
    });
    this.props.handleComplete();
  };

  render() {
    const { isNagShown, isCuratorModalOpen } = this.state;
    const { handleComplete } = this.props;

    return (
      <Box>
        {isNagShown ? (
          <Banner
            experienceId={this.props.experienceId}
            message={i18n._(
              'Want to change up what you see in your home feed?',
              'Title for upsell banner',
            )}
            dismissButtonText={i18n._('Not now', 'Upsell dismiss button')}
            completeButtonText={i18n._('Tune your feed', 'Upsell complete button')}
            onComplete={this.handleCompleteExperience}
            onDismiss={this.handleDismissExperience}
            useNewTab={false}
          />
        ) : null}
        {isCuratorModalOpen ? (
          <CuratorModal
            onDismiss={this.handleHideCuratorModal}
            handleCompleteExperience={handleComplete}
          />
        ) : null}
      </Box>
    );
  }
}
